import { useCallback, useEffect, useRef } from 'react'

import { toast } from '@/utils/helpers'

const DRAIN_MS = 150
const QUEUE_CAP = 50

/**
 * Buffers notification-toast payloads and trickles them into sonner at a
 * paced interval so a burst of WebSocket notifications doesn't mount many
 * toast components in the same React tick (which freezes the UI).
 */
export const useNotificationToastQueue = () => {
  const queueRef = useRef([])
  const drainTimerRef = useRef(null)

  const drain = useCallback(() => {
    if (queueRef.current.length === 0) {
      drainTimerRef.current = null
      return
    }
    const next = queueRef.current.shift()
    toast(next, 'info', { position: 'top-right' })
    drainTimerRef.current = setTimeout(drain, DRAIN_MS)
  }, [])

  const enqueue = useCallback(
    (payload) => {
      if (queueRef.current.length >= QUEUE_CAP) return
      queueRef.current.push(payload)
      if (drainTimerRef.current === null) drain()
    },
    [drain],
  )

  useEffect(
    () => () => {
      if (drainTimerRef.current) clearTimeout(drainTimerRef.current)
    },
    [],
  )

  return enqueue
}

export default useNotificationToastQueue
